__turbopack_context__.v({
  "M": "tag-module-scss-module__uQyiGq__M",
  "S": "tag-module-scss-module__uQyiGq__S",
  "app_light_theme": "tag-module-scss-module__uQyiGq__app_light_theme",
  "root": "tag-module-scss-module__uQyiGq__root",
});
